"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _core = require("@material-ui/core");

var _uiAtoms = require("egov-ui-framework/ui-atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileUploadMultiple = function (_Component) {
  (0, _inherits3.default)(FileUploadMultiple, _Component);

  function FileUploadMultiple() {
    (0, _classCallCheck3.default)(this, FileUploadMultiple);
    return (0, _possibleConstructorReturn3.default)(this, (FileUploadMultiple.__proto__ || Object.getPrototypeOf(FileUploadMultiple)).apply(this, arguments));
  }

  (0, _createClass3.default)(FileUploadMultiple, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          file = _props.file,
          removeFileHandler = _props.removeFileHandler,
          name = _props.name;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        file ? _react2.default.createElement(
          "div",
          { style: { display: "flex", alignItems: "center", marginRight: "10px", color: "#2b0aa5", fontWeight: "500" } },
          _react2.default.createElement(
            "span",
            { style: { marginRight: "10px" } },
            name
          ),
          _react2.default.createElement(_uiAtoms.Icon, { iconName: "close", fontSize: "13px", style: { cursor: "pointer", color: "red" }, onClick: removeFileHandler })
        ) : _react2.default.createElement(
          "div",
          { style: { display: "flex", alignItems: "center" } },
          _react2.default.createElement("input", {
            accept: "image/*,application/pdf",
            id: "contained-button-file",
            multiple: true,
            type: "file",
            style: { display: "none" },
            onChange: onChange
          }),
          _react2.default.createElement(
            "label",
            { htmlFor: "contained-button-file" },
            _react2.default.createElement(
              _core.Button,
              { variant: "contained", component: "span", style: { background: " rgb(254 122 81)", color: "white", marginTop: "16px" } },
              "Upload File"
            )
          )
        )
      );
    }
  }]);
  return FileUploadMultiple;
}(_react.Component);

exports.default = FileUploadMultiple;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/FileUploadMultiple/index.js
// module id = 2147
// module chunks = 1137